import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductListComponent } from './product-list/product-list.component';
import { RouterModule, Routes } from '@angular/router';
import { FormMaterialModule } from 'src/app/form-material.module';
import { SharedModule } from 'src/app/shared.module';
import { AutodrawComponent } from './autodraw/autodraw.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { ResultComponent } from './result/result.component';
import { CoreModule } from 'src/app/core/core.module';
import { OnlyNumbersDirectiveTsDirective } from 'src/app/core/directive/only-numbers/only-numbers.directive.ts.directive';
import { ContactUsComponent } from './contact-us/contact-us.component';

const routes: Routes = [
	{ path: "", redirectTo: "list", pathMatch: "full"},
	{
		path: "list",
		component: ProductListComponent
	},
	{
		path: "list/:id",
		component: ProductDetailComponent
	},
	{
		path: "autodraw",
		component: AutodrawComponent
	},
	{
		path: "autodraw/result",
		component: ResultComponent
	}
]

@NgModule({
	declarations: [
		ProductListComponent,
    	ProductDetailComponent,
     	AutodrawComponent,
      	ResultComponent,
       	ContactUsComponent,
  	],
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		FormMaterialModule,
		SharedModule,
		ComponentsModule,
		CoreModule
	],
})
export class ProductModule {}
